import axios from "./http";
import {
  jsonToBase64,
  decodeCommandResult,
  base64ToJson,
} from "./util/Utils";
import dev from "./models/joinDevice.json";

const URL_APP_WORKSTATIONS = "/api/v1/devices/workstations";
const URL_APP_DEV_INFO = "/api/v1/devices/device-info/";
const URL_APP_DELETE_DEVICE = "/api/v1/devices/delete";
const URL_APP_DEVICE_STATS = "/api/v1/devices/mobile/stats/";
const URL_APP_DEVICE_SOFTWARE_LIST = "/api/v1/devices/software-list/";
const URL_APP_DEVICE_PROCESS_LIST = "/api/v1/devices/proc-list/";
const URL_APP_DEVICE_START_END = "/api/v1/devices/mobile/start-end/";
const URL_APP_WINDOWS_LIST = "/api/v1/devices/windows";
const URL_APP_LINUX_LIST = "/api/v1/devices/linux";
const URL_APP_SERVER_LIST = "/api/v1/devices/server";
const URL_APP_MOBILE_LIST = "/api/v1/devices/mobiles";
const URL_APP_APPLE_LIST = "/api/v1/devices/apple";
const URL_DEVICE_APP_LIST = "/api/v1/devices/mobile/get-apps/";
const URL_LINUX_DEVICE_APPS = "https://dev-core.zion-ng.com/ev1/collector-linux-apps/get-apps";
const URL_LINUX_DEVICE_PROCS = "https://dev-core.zion-ng.com/ev1/linux-procs-endpoint/get-procs";
const URL_LINUX_DEVICE_HEALTH = "https://dev-core.zion-ng.com/ev1/linux-health-collector/get-health";
//const URL_LOGOUT = "/v1/login/checklog";
const URL_FILE_UPLOAD = process.env.REACT_APP_FILES_ENDPOINT + "/upload";
const URL_APP_DEVICE_STATS_BY_DATE = "/api/v1/devices/mobile/stats-bydate/";
const URL_DEVICE_CMD = process.env.REACT_APP_CMD_ENDPOINT + "/cmd/cmd-actions";
const URL_DEVICE_CMD_JOIN =
  process.env.REACT_APP_CMD_ENDPOINT + "/cmd/api-check";
const URL_DEVICE_CMD_CHECK_READY =
  process.env.REACT_APP_CMD_ENDPOINT + "/cmd/cmd-check-ready";
const URL_DEVICE_CMD_CHECK_RESULT =
  process.env.REACT_APP_CMD_ENDPOINT + "/cmd/cmd-get-result";
const URL_DEVICE_ALARM_OFFLINE =
  process.env.REACT_APP_ALARMS_ENDPOINT + "/api/v1/devices/alarms";
const URL_SCHEDULE_TASK = "/api/v1/devices/schedule-tasks";
const configApi = {
  headers: {
    authorization: "Basic YWRtaW46aG9ydXM=",
  },
};
const configUpload = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};
const configCmd = {
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
};
const getApps = {
  headers: {
    authorization: "Basic YWRtaW46aG9ydXM=",
    Accept: "*/*",
  },
};
const configTask = {
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
};
const offTime = 1000 * 60 * 3;

function getDeviceState(timeDevice, devState) {
  let newState = devState;
  let hdev = timeDevice.split(":");
  let tdev = new Date();
  let ttoday = new Date();
  tdev.setHours(hdev[0], hdev[1], hdev[2]);
  let diff = ttoday - tdev;
  if (diff >= offTime) {
    if (devState === dev.typestates.on) newState = dev.typestates.off;
  } else {
    if (diff < 0)
      if (devState === dev.typestates.on) newState = dev.typestates.off;
  }
  return newState;
}

async function updateDeviceData(data) {
  if (typeof data === "object" && data.length > 0) {
    for (let i = 0; i < data.length; i++) {
      let currentDev = data[i];
      let timeDevice = currentDev.timeon;
      currentDev.state = getDeviceState(timeDevice, currentDev.state);
      if (currentDev.type === dev.types.android) {
        const stat = await getFinalDeviceStat(currentDev.id);
        if (stat) currentDev.battery = stat.batstat;
        else currentDev.battery = "0";
      } else {
        currentDev.battery = "N/A";
      }
    }
    return data;
  } else {
    return [];
  }
}

export async function getWorkstations() {
  const response = await axios
    .get(URL_APP_WORKSTATIONS, configApi)
    .catch(function (error) {
      if (typeof error === "object") return error;
      else return error.toJSON();
    });
  if (response.status === 200) {
    let data = response.data.workstations;
    return updateDeviceData(data);
  } else {
    return null;
  }
}

export async function getDevice(id) {
  const response = await axios
    .get(URL_APP_DEV_INFO + id, configApi)
    .catch(function (error) {
      return error.toJSON();
    });
  if (response.status === 200) {
    const data = response.data["dev-info"];
    if (data) return data[0];
    else return null;
  } else return null;
}

export async function deleteDevice(id) {
  const data = {};
  data.botid = id;
  const dataEncripted = jsonToBase64(data);
  const response = await axios
    .post(URL_APP_DELETE_DEVICE, dataEncripted, configApi)
    .catch(function (error) {
      return error.toJSON();
    });
  console.log(URL_APP_DELETE_DEVICE, response);
  if (response.status === 200) {
    return true;
  } else {
    return false;
  }
}

export async function getDeviceStats(id) {
  const response = await axios
    .get(URL_APP_DEVICE_STATS + id, configApi)
    .catch(function (error) {
      return error.toJSON();
    });
  if (response.status === 200) {
    if (response.data["mob-stat"]) return response.data["mob-stat"];
    else return [];
  } else return [];
}

export async function getFinalDeviceStat(id) {
  const stats = await getDeviceStats(id);
  if (stats.length > 0) {
    return stats[stats.length - 1];
  } else {
    return null;
  }
}

export async function getDeviceStatsWithNumberOfRecords(id, numberOfRecords) {
  const stats = await getDeviceStats(id);
  if (stats.length > 0) {
    if (stats.length <= numberOfRecords) {
      return stats;
    } else {
      return stats.slice(stats.length - numberOfRecords, stats.length);
    }
  } else {
    return [];
  }
}

export async function getWorkstationsByType(type) {
  let correctType = false;
  Object.values(dev.types).forEach((element) => {
    if (element === type) correctType = true;
  });
  if (correctType) {
    const response = await getWorkstations();
    if (response.length > 0) {
      let list = [];
      response.forEach((element) => {
        if (element.type === type) list.push(element);
      });
      return list;
    } else return [];
  } else return [];
}


export async function getDeviceSoftwareList(id) {
  const response = await axios
    .get(URL_APP_DEVICE_SOFTWARE_LIST + id, configApi)
    .catch(function (error) {
      return error.toJSON();
    });
  if (response.status === 200) {
    if (response.data["dev-info"]) return response.data["dev-info"];
    else return [];
  } else return [];
}

export async function getDeviceProcessList(id) {
  const response = await axios
    .get(URL_APP_DEVICE_PROCESS_LIST + id, configApi)
    .catch(function (error) {
      return error.toJSON();
    });
  if (response.status === 200) {
    if (response.data["dev-info"]) return response.data["dev-info"];
    else return [];
  } else return [];
}

export async function getDeviceStartEnd(id) {
  const response = await axios
    .get(URL_APP_DEVICE_START_END + id, configApi)
    .catch(function (error) {
      return error.toJSON();
    });

  if (response.status === 200) {
    if (response.data) {
      const data = response.data;
      let start = data.slice(0, data.length / 2);
      let end = data.slice(data.length / 2, data.length);
      start = JSON.parse(start);
      start = start["mob-startend"][0]["date"];
      end = JSON.parse(end);
      end = end["mob-startend"][0]["date"];
      return { start: start, end: end };
    } else return null;
  } else return null;
}

export async function getWindowsList() {
  const response = await axios
    .get(URL_APP_WINDOWS_LIST, configApi)
    .catch(function (error) {
      return error.toJSON();
    });
  if (response.status === 200) {
    const data = response.data.workstations;
    return updateDeviceData(data);
  } else return null;
}

export async function getLinuxList() {
  const response = await axios
    .get(URL_APP_LINUX_LIST, configApi)
    .catch(function (error) {
      return error.toJSON();
    });
  if (response.status === 200) {
    const data = response.data.workstations;
    return updateDeviceData(data);
  } else return null;
}

export async function getServerList() {
  const response = await axios
    .get(URL_APP_SERVER_LIST, configApi)
    .catch(function (error) {
      return error.toJSON();
    });
  if (response.status === 200) {
    const data = response.data.workstations;
    return updateDeviceData(data);
  } else return null;
}

export async function getMobileList() {
  const response = await axios
    .get(URL_APP_MOBILE_LIST, configApi)
    .catch(function (error) {
      return error.toJSON();
    });
  if (response.status === 200) {
    const data = response.data.workstations;
    data.forEach((item) => {
      item.carrier = "ENTEL";
    });
    return updateDeviceData(data);
  } else return null;
}

export async function getAppleList() {
  const response = await axios
    .get(URL_APP_APPLE_LIST, configApi)
    .catch(function (error) {
      return error.toJSON();
    });
  if (response.status === 200) {
    const data = response.data.workstations;
    return updateDeviceData(data);
  } else return null;
}

export async function uploadFile(formData) {
  const response = await axios
    .post(URL_FILE_UPLOAD, formData, configUpload)
    .catch((error) => {
      return error.toJSON();
    });
  if (response.status === 200) {
    return true;
  } else return false;
}

export async function getDeviceStatByDate(id, initDate, endDate) {
  const initDateString =
    initDate.getFullYear() +
    "-" +
    (initDate.getMonth() + 1) +
    "-" +
    initDate.getDate() +
    "_" +
    [initDate.getHours(), initDate.getMinutes(), initDate.getSeconds()].join(
      ":"
    );
  const endDateString =
    endDate.getFullYear() +
    "-" +
    (endDate.getMonth() + 1) +
    "-" +
    endDate.getDate() +
    "_" +
    [endDate.getHours(), endDate.getMinutes(), endDate.getSeconds()].join(":");
  const path =
    URL_APP_DEVICE_STATS_BY_DATE +
    id +
    "/" +
    initDateString +
    "/" +
    endDateString;
  const response = await axios.get(path, configApi).catch(function (error) {
    return error.toJSON();
  });
  if (response.status === 200) {
    if (response.data["mob-stat"]) return response.data["mob-stat"];
    else return [];
  } else return [];
}

const sleep = (time) =>
  new Promise((resolve) => {
    setTimeout(() => {
      console.log("end timer");
      resolve();
    }, time);
  });

async function checkReady(
  id,
  sesionId,
  timeRequest = 1000 * 30,
  maxRequest = 5
) {
  var response = false;
  var counter = 0;
  while (true) {
    if (counter > maxRequest) {
      break;
    }
    await sleep(timeRequest);
    response = await commandCheckReady(id, sesionId);
    if (response === null && counter > maxRequest) break;
    if (response === false && counter > maxRequest) break;
    if (response === true) break;
    counter++;
  }
  if (response === null) response = false;
  return response;
}

export async function commandDevice(id, sesionId, command) {
  const cmdEncripted = jsonToBase64(command);
  console.log("command", command, cmdEncripted);
  const body = { ID: id, SID: sesionId, CMD: cmdEncripted };
  const response = await axios
    .post(URL_DEVICE_CMD, JSON.stringify(body), configCmd)
    .catch(function (error) {
      return error.toJSON();
    });
  console.log(URL_DEVICE_CMD, response);
  if (response.status === 200) {
    const isReady = await checkReady(id, sesionId);
    if (isReady === true) {
      return await commandCheckResult(id, sesionId);
    } else return null;
  } else {
    return null;
  }
}

export async function commandCheckReady(id, sesionId) {
  const body = { ID: id, SID: sesionId };
  const response = await axios
    .post(URL_DEVICE_CMD_CHECK_READY, JSON.stringify(body), configCmd)
    .catch(function (error) {
      return error.toJSON();
    });
  console.log(URL_DEVICE_CMD_CHECK_READY, response);
  if (response.status === 200) {
    if (response.data && response.data["cmdready"] === "yes") return true;
    else return false;
  } else {
    return null;
  }
}

export async function commandCheckResult(id, sesionId) {
  const body = { ID: id, SID: sesionId };
  const response = await axios
    .post(URL_DEVICE_CMD_CHECK_RESULT, JSON.stringify(body), configCmd)
    .catch(function (error) {
      return error.toJSON();
    });
  console.log(URL_DEVICE_CMD_CHECK_RESULT, response);
  if (response.status === 200) {
    // "empty" (RESULT === "") is a legitimate result - the command ran and
    // produced no output - so it resolves the same as "ok". "missing" and
    // "invalid" collapse into null like every other error path here; the
    // UI shows a generic error state for those instead of a distinct one
    // since there is nothing actionable to tell them apart.
    const { status, text } = decodeCommandResult(
      response.data && response.data["result"]
    );
    if (status === "ok" || status === "empty") return text;
    return null;
  } else {
    return null;
  }
}

export async function getShellDevice(data) {
  const response = await axios
    .post(URL_DEVICE_CMD_JOIN, JSON.stringify(data), configCmd)
    .catch(function (error) {
      if (typeof error === "string") return error.toJSON();
      else return error;
    });
  console.log(URL_DEVICE_CMD_JOIN, response);
  if (response.status === 200) {
    if (response.data && response.data[0][1] === "yes") return true;
    else return false;
  } else {
    return false;
  }
}

export async function sendAlarmOffline(data) {
  const response = await axios
    .post(URL_DEVICE_ALARM_OFFLINE, JSON.stringify(data), configCmd)
    .catch(function (error) {
      return error.toJSON();
    });
  if (response.status === 200) {
    return true;
  } else {
    return false;
  }
}

export async function getApplicationList(id) {
  const response = await axios
    .get(URL_DEVICE_APP_LIST + id, getApps)
    .catch(function (error) {
      return error.toJSON();
    });
  console.log(URL_DEVICE_APP_LIST, response);
  if (response.status === 200) {
    if (response.data && response.data !== "None") {
      const decoded = base64ToJson(response.data);
      return decoded.apps;
    } else return null;
  } else {
    return null;
  }
}

export async function getLinuxApplicationList(botId) {
  const requestBody = {
    BotID: botId
  };
  const encodedBody = jsonToBase64(requestBody);

  const response = await axios
    .post(URL_LINUX_DEVICE_APPS, encodedBody, getApps)
    .catch(function (error) {
      console.error("Error fetching Linux apps:", error);
      return error.toJSON();
    });

  console.log(URL_LINUX_DEVICE_APPS, response);
  if (response.status === 200 && response.data) {
    if (response.data.status === "success" && response.data.apps) {
      return response.data.apps;
    } else {
      return [];
    }
  } else {
    return [];
  }
}

export async function getLinuxProcessList(botId) {
  const requestBody = {
    BotID: botId
  };
  const encodedBody = jsonToBase64(requestBody);

  const response = await axios
    .post(URL_LINUX_DEVICE_PROCS, encodedBody, getApps)
    .catch(function (error) {
      console.error("Error fetching Linux processes:", error);
      return error.toJSON();
    });

  console.log(URL_LINUX_DEVICE_PROCS, response);
  if (response.status === 200 && response.data) {
    if (response.data.status === "success" && response.data.processes) {
      return response.data.processes;
    } else {
      return [];
    }
  } else {
    return [];
  }
}

// Health samples for a Linux device. `window` is an optional
// { start_date, end_date } pair of UTC "YYYY-MM-DD HH:mm:ss.SSS" strings;
// omitting it asks the collector for the full retained history.
//
// Unlike the older helpers in this file this one throws instead of returning
// [] on failure. A monitor that silently renders "no samples" when the
// collector is unreachable is worse than one that says so, and the caller
// (useLinuxHealth) turns the rejection into a visible error state.
export async function getLinuxHealth(botId, window) {
  const requestBody = { BotID: botId, ...(window || {}) };
  const encodedBody = jsonToBase64(requestBody);

  const response = await axios.post(
    URL_LINUX_DEVICE_HEALTH,
    encodedBody,
    getApps
  );

  if (response.data && response.data.status === "success") {
    return Array.isArray(response.data.metrics) ? response.data.metrics : [];
  }
  throw new Error("Unexpected health response");
}

export async function getDataFromRemoteDevice(id) {
  return null;
}

export async function sendAction(
  initDate,
  endDate,
  shellType,
  command,
  description
) {
  const initDateString =
    initDate.getFullYear() +
    "-" +
    (initDate.getMonth() + 1) +
    "-" +
    initDate.getDate();
  const endDateString =
    endDate.getFullYear() +
    "-" +
    (endDate.getMonth() + 1) +
    "-" +
    endDate.getDate();
  const cmdEncripted = jsonToBase64(command);
  const body = {
    INIT: initDateString,
    END: endDateString,
    SHELL: shellType,
    CMD: cmdEncripted,
    DES: description,
  };
  console.log("body", body);
  const response = await axios
    .post(URL_SCHEDULE_TASK, JSON.stringify(body), configTask)
    .catch(function (error) {
      return error.toJSON();
    });
  console.log(URL_SCHEDULE_TASK, response);
  if (response.status === 200) {
    return true;
  } else {
    return false;
  }
}
